import { createGlobalStyle } from 'styled-components';

// Bootstrap
import './bootstrap.scss';

// Utils
import breakpoint from '../../utils/breakpoints';
import { colors } from '../../utils/variables';

// Fonts
import Poppins400 from '../fonts/Poppins-Regular.woff2';
import Poppins500 from '../fonts/Poppins-Medium.woff2';
import Poppins600 from '../fonts/Poppins-SemiBold.woff2';
import Poppins700 from '../fonts/Poppins-Bold.woff2';

// Helpers
import { Helpers } from './helpers';

const GlobalStyles = createGlobalStyle`

@font-face {
  font-family: 'Poppins';
  src: url(${Poppins400}) format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Poppins';
  src: url(${Poppins500}) format('woff2');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Poppins';
  src: url(${Poppins600}) format('woff2');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Poppins';
  src: url(${Poppins700}) format('woff2');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

html {
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden;
  scroll-behavior: smooth;

  &.no-scroll {
    overflow: hidden;
  }
}

  body {
    font-family: "Poppins", sans-serif !important;
    color: ${colors.dark};
    background-color: ${colors.cream};
    font-size: 20px;
    line-height: 1.4em;
    margin: 0;
    padding: 0;
    width: 100%;
    overflow-x: hidden;

    &.no-scroll {
      overflow: hidden;
    }

    :focus-visible {
      outline: 2px solid ${colors.fuscia_medifar};
      outline-offset: 3px;
      border-radius: 2px;
    }

    a {
      font-size: 16px;
      line-height: 19.2px;
      color: inherit;
      text-decoration: none;

      &.size--small {
        font-size: 18px;
        line-height: 26px;
      }
    }

    p {
      font-size: 16px;
      line-height: 19.2px;
    }
    
    h1,
    h2,
    h3,
    h4 {
      margin: 0;
      font-weight: 400;
      line-height: 1.2em;
    }

    h1 {
      font-size: 36px;
      line-height: 43.2px;

      ${breakpoint.medium`
        font-size: 64px;
        line-height: 76.8px;

      `}
    }

    h2 {
      font-size: 34px;
      line-height: 38.4px;


      ${breakpoint.medium`
        font-size: 48px;
        line-height: 56px;

      `}
    }
    
    h3 {
      font-size: 24px;

      ${breakpoint.medium`
        font-size: 40px;
      `}
    }

    h4 {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: .02em;
      line-height: 22.4px;

    }
  }

  ${Helpers}

  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }

    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;

export default GlobalStyles;
